import React from 'react';
import Tooltip from '@components/Tooltip';
import InfoSvg from '@images/info.svg';
import Label from '../Label';

type Props = {
  label: string;
  id: string;
  name?: string;
  required?: boolean;
  placeholder?: string;
  infotext?: string;
  min_chars?: number;
  max_chars?: number;
  pattern?: string;
};

function Textarea(props: Props) {
  const { label, id, name, required, placeholder, infotext, min_chars, max_chars, pattern } = props;

  return (
    <div className='textarea'>
      <div className='label__container'>
        <Label text={`${label}${required ? ' *' : ''}`} htmlFor={id} />

        {infotext && infotext.length > 0 ? (
          <Tooltip text={infotext}>
            <InfoSvg />
          </Tooltip>
        ) : null}
      </div>

      <textarea
        id={id}
        name={name ?? id}
        required={required}
        placeholder={placeholder}
        {...(min_chars ? { minLength: min_chars } : {})}
        {...(max_chars ? { maxLength: max_chars } : {})}
        {...(pattern ? { pattern } : {})}
      />
    </div>
  );
}

export default Textarea;
